import { Box, TextArea as GrommetTextArea, Text, TextAreaProps } from 'grommet'
import { HTMLInputTypeAttribute } from 'react'
import { useFormContext } from 'react-hook-form'

interface FormInputFieldProps extends TextAreaProps {
  style?: React.CSSProperties
  label?: string
  errorMessage?: string
  type?: HTMLInputTypeAttribute | undefined
  name: string
  className?: string
  maxLength?: number
}

export const TextAreaField = ({
  placeholder = 'type here',
  label,
  errorMessage,
  type,
  name = 'name',
  maxLength,
  ...props
}: FormInputFieldProps) => {
  const {
    register,
    formState: { errors }
  } = useFormContext()

  const errorText = errors[name]?.message
  const displayError = errorText && typeof errorText === 'string' ? errorText : errorMessage

  return (
    <>
      {label && (
        <Text margin={{ bottom: '0px' }} style={{ fontSize: '14px', fontWeight: 500 }}>
          {label}
        </Text>
      )}
      <GrommetTextArea
        maxLength={maxLength}
        placeholder={placeholder}
        {...register(name)}
        resize={false}
        {...props}
        style={{ borderRadius: '6px', minHeight: '140px', ...props.style }}
      />
      {displayError && (
        <Box pad={{ left: 'small' }}>
          <Text color="status-error" size="small">
            {displayError}
          </Text>
        </Box>
      )}
    </>
  )
}
